<template>
  <div>
    <vd-coremedia
      :key="playerKey"
      id="coremedia"
      :token="customerToken"
      :broadcastId="learningObject.broadcast.id"
      :mute="mute"
      :customerId="customerId"
      :email="studentEmail"
      :localSrc="localSrc"
      :isOffline="isOffline"
      :localSubtitles="localSubtitles"
      :autoplay="config.autoplay"
      :customFullscreen="$isIos"
      :initialPlaybackRate="config.initialPlaybackRate"
      :env="coremediaEnv"
      showControlBar="true"
      skinClass="vjs-theme-vxl"
      :continue="config.startFromLastSavedState"
      :startFrom="this.$route.query.time"
      playbackRates ='[0.75,1,1.25,1.5,1.75,2,2.5,3]'
      components='[ "playToggle","currentTimeDisplay","timeDivider","durationDisplay","progressControl","customControlSpacer","subsCapsButton","volumePanel","fullscreenToggle" ]'
      @time="updateTime($event)"      
    >
      <div
        :class="{ player: true, fs: fullscreen }"
        @mouseover="hover = true"
        @mouseleave="hover = false"
      >
        <vd-player
          ref="vdplayer"
          :class="{ 'fs-z-index': fullscreen }"
          @useractive="handleUserActive"
          @userinactive="handleUserInactive"
          @started="handleStarted"
          @ended="handleEnded"
          @ready="playerReady($event)"
          @enterfullscreen="handleEnterFullscreen"
          @exitfullscreen="handleExitFullscreen"
        >
        </vd-player>
        <div class="overlay vjs-waiting" v-if="overlayVisible">
          <div class="vjs-loading-spinner"></div>
        </div>

        <div class="unmute" v-if="unmuteVisible" @click="handleUnmute">
          <a class="waves-effect btn-large">
            <i class="material-icons left">volume_up</i>Ativar som
          </a>
        </div>

        <!-- `.bar-right` é absoluto com z-index 9, contra 5 do overlay: sem
             esconder, engrenagem e notas flutuam sobre o preto do loading
             oferecendo ações que não existem enquanto não há player.
             v-show e não v-if porque o playerReady MOVE este nó pra dentro do
             #videojsPlayer — recriá-lo desfaria a realocação. -->
        <div id="controllers" v-show="!overlayVisible">
          <div
            id="barRight"
            class="bar-right"
            :class="isVimeo ? (hover ? 'vimeo active' : 'vimeo') : ''"
          >
            <div
              v-show="!isVimeo"
              class="right-button"
              :class="{ move: userActive }"
              @click="showSettings"
            >
              <img src="@/assets/icons/settings.svg" />
            </div>
            <div
              class="right-button"
              :class="{ move: userActive }"
              @click="showNotes"
            >
              <img src="@/assets/icons/notes.svg" />
            </div>
            <!-- <div class="right-button" @click="toggleLibras">
              <img src="@/assets/icons/libras.svg" />
            </div>-->
          </div>
          <!-- <div class="libras-button" :class="{'upLibras' : userActive}" :style="{ display: librasVisible && (currentOrientation != 0 || fullscreen) ? 'flex' : 'none' }">
              <div class="box-Libras-FullScreen">
                <div class="libras">
                  <video src="@/assets/images/libras.mp4" autoplay loop></video>
                </div>
              </div>
          </div>-->
        </div>

        <div
          class="modals"
          :style="{ display: settingsVisible ? 'flex' : 'none' }"
        >
          <div class="modal-header">
            <div class="modal-title">Configurações</div>
            <button class="modal-close" @click="hideSettings">
              <img src="@/assets/icons/close.svg" alt />
            </button>

            <div class="toggles" v-if="false">
              <input
                type="checkbox"
                name="toggleSettings"
                id="checkbox1"
                class="modal-toggle"
                checked
              />
              <label
                for="checkbox1"
                class="checkbox-label"
                data-off="Desligado"
                data-on="Ligado"
              ></label>
            </div>
          </div>

          <div class="modal-content">
            <div class="modal-section">Velocidade de Reprodução</div>

            <vd-playback-rate-control
              class="playback-rate-control"
              v-slot="{ playbackRates, selectedPlaybackRate, setPlaybackRate }"
            >
              <div class="modal-options" id="speedOptions">
                <button
                  v-for="playbackRate in playbackRates"
                  class="modal-btn-option"
                  :class="{ selected: playbackRate == selectedPlaybackRate }"
                  @click="handlePlaybackRate(playbackRate, setPlaybackRate)"
                  :key="playbackRate"
                >
                  {{ playbackRate }}x
                </button>
              </div>
            </vd-playback-rate-control>

            <vd-bitrate-control
              class="bitrate-control"
              v-slot="{ levels, selectedBitrate, setBitrate }"
            >
              <div class="modal-section" v-if="levels && levels.length">
                Resolução
              </div>
              <div
                class="modal-options"
                id="qualityOptions"
                v-if="levels && levels.length"
              >
                <button
                  v-for="level in levels"
                  class="modal-btn-option"
                  :class="{ selected: level.bitrate == selectedBitrate }"
                  @click="setBitrate(level.bitrate)"
                  :key="level.bitrate"
                >
                  {{ level.height }}p
                </button>
                <button
                  class="modal-btn-option"
                  :class="{ selected: selectedBitrate == 'auto' }"
                  @click="setBitrate('auto')"
                >
                  auto
                </button>
              </div>
            </vd-bitrate-control>
          </div>
        </div>

        <div
          class="modals"
          :style="{ display: notesVisible ? 'flex' : 'none' }"
        >
          <div class="modal-header">
            <div class="modal-title">
              <img src="@/assets/icons/notes.png" alt />Anotações
            </div>
            <button class="modal-close" @click="hideNotes">
              <img src="@/assets/icons/close.svg" alt />
            </button>

            <div class="toggles" v-if="false">
              <input
                type="checkbox"
                name="toggleSettings"
                id="checkbox2"
                class="modal-toggle"
              />
              <label
                for="checkbox2"
                class="checkbox-label"
                data-off="Desligado"
                data-on="Ligado"
              ></label>
            </div>
          </div>

          <div class="modal-content">
            <div class="modal-box-notes">
              <textarea                
                id="box-notes"
                ref="boxnotes"
                maxlength="140"
                rows="4"
                v-model="notesText"
              ></textarea>
            </div>
            <div class="notes-group1">
              <div class="notes-count" id="noteCount">
                {{ 140 - notesText.length }}
              </div>
              <div class="notes-send" @click="createNote">
                <template v-if="notesSending">
                  <div class="preloader-wrapper smaller active">
                    <div class="spinner-layer">
                      <div class="circle-clipper left">
                        <div class="circle"></div>
                      </div>
                      <div class="gap-patch">
                        <div class="circle"></div>
                      </div>
                      <div class="circle-clipper right">
                        <div class="circle"></div>
                      </div>
                    </div>
                  </div>
                  ENVIANDO
                </template>
                <template v-else>
                  <img src="@/assets/icons/send.png" alt /> ENVIAR
                </template>
              </div>
            </div>

            <div class="notes-group2">
              <div class="note-time-video">{{ currentTime | time }}</div>
              <div class="note-msg">Nota disponível apenas para você.</div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="box-libras" :style="{ display: librasVisible && (currentOrientation == 0 && !fullscreen) ? 'flex' : 'none' }">
        <div class="libras">
          <video src="@/assets/images/libras.mp4" autoplay loop></video>
        </div>
      </div>-->
    </vd-coremedia>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { VxlNavGestures } from "@/plugins/vxlNavGestures";
import { offlineStorage } from "@/services/offline/offlineStorage";

// Prioridade de reprodução: a fila de download só cede banda quando o player
// está SOFRENDO — não a cada play. Em conexão boa o download continua com
// todas as conexões enquanto o aluno assiste; quem dispara a redução é o
// stall, não o simples fato de haver vídeo rodando.
//
// Os dois limiares e o tempo de espera formam a histerese. Sem ela a fila
// oscilaria — cede banda, o buffer enche, devolve, engasga de novo — e cada
// volta custa um batch reenfileirado, que é justamente o que a feature quer
// evitar.
const STALL_BUFFER_S = 8;
const HEALTHY_BUFFER_S = 25;
const RECOVERY_MS = 8000;

export default {
  props: [
    "learningObject",
    "studentEmail",
    "mute",
    "customerId",
    "customerToken",
    "localSrc",
    "isOffline",
    "offlineResumeFrom",
    // [{src, srclang, label}] — legendas .vtt locais da aula baixada, repassadas
    // ao bundle (que as usa no lugar do stub vazio do mountLocalSource). Fora da
    // playerKey de propósito: flipa junto com localSrc, que já está na key.
    "localSubtitles",
  ],
  data() {
    return {
      userActive: true,
      settingsVisible: false,
      notesVisible: false,
      librasVisible: false,
      fullscreen: false,
      isVimeo: false,
      hover: false,
      notesText: "",
      notesSending: false,
      currentOrientation: 0,
      currentTime: 0,
      coremediaEnv: process.env.VUE_APP_ENV,
      unmuteVisible: false,
      seekPosition: this.$route.query.time,
      overlayVisible: true
    };
  },
  mounted() {
    this.currentOrientation = screen.orientation
      ? screen.orientation.angle
      : window.orientation;
    window.addEventListener("orientationchange", this.updateOrientation);
    // Entrada de histórico descartável que o voltar consome no lugar da rota.
    // Fora de `data` de propósito: é bookkeeping de histórico, nada disso pinta.
    this._fsHistoryEntry = false;
    this._fsReleasingEntry = false;
    // Estado da detecção de sofrimento do player. Fora de `data` porque nada
    // disso pinta na tela — é só bookkeeping para decidir a concorrência.
    this._playbackActive = false;
    this._seeking = false;
    this._bufferWasHealthy = false;
    this._recoveryTimer = null;
    window.addEventListener("popstate", this.handleHistoryBack);
    // Scroll lock do body e swipe nativo: estado imperativo do ciclo de
    // fullscreen iOS, mesmo caso do bookkeeping acima.
    this._fsScrollLockY = null;
    this._fsSwipeDisabled = false;
    this._fsEdgeTouch = null;
    window.addEventListener("touchstart", this.handleFsEdgeTouchStart, { passive: true });
    window.addEventListener("touchmove", this.handleFsEdgeTouchMove, { passive: true });
  },
  beforeDestroy() {
    // O componente não tinha hook de destruição nenhum. Duas consequências:
    // a classe do body ficava para trás quando a rota mudava com o player em
    // fullscreen, e o listener de orientação nunca era removido — cada visita a
    // uma aula deixava mais um preso na window, todos apontando pra instâncias
    // mortas.
    //
    // A entrada de fullscreen é ABANDONADA, não liberada: liberar é um
    // history.back(), e aqui a navegação já está em curso — voltar no meio dela
    // levaria o aluno uma tela além da que ele pediu. Sobrar a entrada é
    // inofensivo, porque ela aponta para a URL desta mesma aula.
    this._fsHistoryEntry = false;
    this.resetFullscreenState();
    // Também limpa o timer de recuperação: sem isso ele dispararia depois do
    // componente morrer e zeraria a flag por cima da aula seguinte.
    this.stopStreamingPlayback();
    window.removeEventListener("orientationchange", this.updateOrientation);
    window.removeEventListener("popstate", this.handleHistoryBack);
    window.removeEventListener("touchstart", this.handleFsEdgeTouchStart);
    window.removeEventListener("touchmove", this.handleFsEdgeTouchMove);
  },
  watch: {
    // O overlay só é desligado no playerReady, e este wrapper NÃO é recriado
    // quando o <vd-coremedia> é — sem religar aqui, o loading aparecia só na
    // primeira aula da sessão.
    //
    // Observa a playerKey, não o id da transmissão: a key é exatamente o que
    // reconstrói o player, e ela também muda quando SÓ a fonte troca (baixar ou
    // remover a aula). Nesse caminho o bundle leva o manifestUrl a null e não
    // renderiza nada — sem religar o overlay, a área reservada do `.player`
    // ficava um vazio preto por todo o tempo do GET do manifesto.
    playerKey (newKey, oldKey) {
      if (newKey === oldKey) return;
      this.overlayVisible = true;
      // O <vd-coremedia> vai ser destruído e recriado, e o player novo nasce
      // fora do fullscreen. Sem zerar aqui, o wrapper continuaria com `.fs`
      // aplicado sobre um player que não sabe disso.
      //
      // A entrada de fullscreen é ABANDONADA, não liberada, pelo mesmo motivo do
      // beforeDestroy: esta key muda também quando o aluno toca outra aula da
      // sidenav, e aí o router já empilhou a aula nova — o history.back() do
      // release o mandaria de volta para a anterior. O preço de abandonar é uma
      // entrada com a URL desta aula sobrando quando a key muda SEM navegação
      // (download terminou, entrou/saiu do modo offline): o voltar seguinte cai
      // nela, o router descarta como rota duplicada e nada acontece na tela.
      this._fsHistoryEntry = false;
      this.resetFullscreenState();
      // O player novo nasce parado e reaquece o buffer do zero. Sem isto,
      // trocar pra uma aula baixada (key local) deixaria a flag presa em true
      // até sair da página, e o timer de recuperação da aula velha ainda
      // dispararia sobre a nova.
      this.stopStreamingPlayback();
    },
    // Folga de buffer: o piso liga a prioridade, o teto a devolve. A zona entre
    // os dois não decide nada — só cancela uma devolução já agendada, pra que a
    // banda só volte depois de uma recuperação sustentada.
    //
    // O piso exige ter visto o buffer saudável antes: no começo de toda aula a
    // folga é pequena porque o buffer ainda está enchendo, e sem essa guarda
    // cada play cairia como se fosse conexão ruim. Enquanto isso não acontece,
    // quem denuncia sofrimento é o `waiting`.
    bufferAhead (seconds) {
      if (seconds == null || !this._playbackActive || this.localSrc) return;
      if (seconds >= HEALTHY_BUFFER_S) {
        this._bufferWasHealthy = true;
        this.schedulePlaybackRecovery();
      } else if (this._bufferWasHealthy && seconds <= STALL_BUFFER_S) {
        this.markPlaybackStruggling();
      } else {
        this.cancelPlaybackRecovery();
      }
    },
    "$route.query.time": function () {
      if (this.seekPosition != this.$route.query.time) {
        this.seekPosition = this.$route.query.time;
        this.playerSeek();
      }
    },
  },
  computed: {
    ...mapState({
      config: (state) => state.config,
      currentEnroll: (state) => state.enroll.current,
      learningObjects: (state) => state.enroll.currentLearningObjects,
      currentLearningObject: (state) => state.enroll.currentLearningObject,
    }),

    // Segundos de vídeo já bufferizados à frente do playhead. Os dois campos
    // são do store do bundle e já são reativos — o `bufferedEnd` é atualizado
    // pelo `progress` do video.js e o `currentTime` pelo `timeupdate`, então dá
    // pra ler a saúde da reprodução sem tocar no bundle nem criar polling.
    bufferAhead () {
      const cm = this.$store.state.coremedia;
      if (!cm) return null;
      const { bufferedEnd, currentTime } = cm;
      if (typeof bufferedEnd !== "number" || typeof currentTime !== "number") return null;
      return bufferedEnd - currentTime;
    },

    // Key reativa pra forçar o <vd-coremedia> a reinstanciar (e re-dispatch o
    // coremedia/load) quando o source efetivo muda dentro da mesma aula.
    // Necessário porque o componente do bundle CoreMedia faz dispatch apenas
    // no created() — sem watcher pra localSrc/isOffline. Sem essa key reativa:
    //   - User baixa aula estando na tela dela (online) → localSrc muda de
    //     null pra URL local, mas player continua na URL stream antiga.
    //   - User ativa modo avião com aula tocando → isOffline true, mas player
    //     não troca pro caminho offline do coremedia.
    // Mudar o :key força Vue a destruir/recriar o componente. Trade-off: se
    // o user estava tocando, vai voltar pro início — aceitável nessa transição.
    playerKey () {
      const localState = this.localSrc ? 'local' : 'remote';
      const offlineState = this.isOffline ? 'off' : 'on';
      return `${this.learningObject.broadcast.id}-${localState}-${offlineState}`;
    },

    // nextLearningObjects() {
    //   if (!this.currentLearningObject) return {};

    //   const structureType = this.currentEnroll.structureType.toLowerCase();

    //   const currentLearningObjectIndex = this.learningObjects
    //     .map(lo => lo.id)
    //     .indexOf(this.currentLearningObject.id);

    //   var nextLearningObjects = [];

    //   for (
    //     var i = currentLearningObjectIndex + 1;
    //     i < this.learningObjects.length;
    //     i++
    //   ) {
    //     nextLearningObjects.push(this.learningObjects[i]);

    //     if (nextLearningObjects.length > 2) break;
    //   }

    //   return nextLearningObjects[0];
    // }
  },
  methods: {
    updateTime(time) {
      this.currentTime = Math.floor(time);
      // Guarda a posição pra ela sobreviver à recriação do <vd-coremedia> pela
      // playerKey (fim de download troca online→local, e entrar/sair do modo
      // offline). Sem isto o vídeo volta ao início bem no meio da aula.
      //
      // Campo NÃO reativo: só é lido no remount, e `time` dispara a cada
      // segundo — deixar reativo criaria render a cada tick à toa.
      //
      // Guardado junto com o id da transmissão porque este wrapper NÃO é
      // recriado ao trocar de aula (só o filho é, pela key). Sem o par, a
      // próxima aula começaria na posição da anterior.
      const broadcast = this.learningObject && this.learningObject.broadcast;
      if (broadcast && broadcast.id != null) {
        this._resumeBroadcastId = broadcast.id;
        this._resumeSeconds = this.currentTime;
      }
      this.$emit('time', this.currentTime);
    },
    playerSeek() {
      if (this.$refs.vdplayer.player.currentTime !== undefined) {
        this.$refs.vdplayer.player.currentTime(this.seekPosition);
      }
      if (this.$refs.vdplayer.player.setCurrentTime !== undefined) {
        this.$refs.vdplayer.player.setCurrentTime(this.seekPosition);
      }
    },
    playerReady(event) {
      // copia os controles para dentro do elemento bugfix: não aparecia no fullscreen
      var cElements = document.querySelectorAll(
        ".player .modals, .player #controllers"
      );
      for (var i in cElements) {
        if (typeof cElements[i] != "object") continue;

        document.getElementById("videojsPlayer").appendChild(cElements[i]);
      }

      if (event.IsVimeo) {
        this.isVimeo = true;
        document.querySelector("#barRight").classList += " vimeo";
      }

      // Fora do iOS o fullscreen é do próprio video.js e o bundle NÃO emite
      // enterfullscreen/exitfullscreen — o buildBtnFullscreen só troca o
      // FullscreenToggle pelo botão que emite sob `customFullscreen`, que é
      // `$isIos`. Sem este gancho a entrada de histórico nunca seria empilhada no
      // Android, e o voltar continuaria saindo da aula.
      this.$refs.vdplayer.player.on("fullscreenchange", () => {
        const player = this.$refs.vdplayer && this.$refs.vdplayer.player;
        if (!player || typeof player.isFullscreen !== 'function') return;
        if (player.isFullscreen()) {
          this.pushFullscreenHistoryEntry();
        } else if (!this.fullscreen) {
          // O `!this.fullscreen` protege o iOS: lá o estado é o da classe .fs e a
          // saída passa pelo exitfullscreen do bundle, não por aqui.
          this.releaseFullscreenHistoryEntry();
        }
      });

      // Prioridade de reprodução. A flag segue os eventos REAIS do player, não o
      // par started/ended do bundle: o `started` é emitido uma única vez por
      // instância (guarda `i.started` lá dentro), então o replay depois do fim
      // não voltaria a ligá-la.
      //
      // Reproduzir NÃO liga mais a flag sozinho — só marca a reprodução como
      // ativa. Quem liga é o sinal de sofrimento (`waiting` ou buffer no piso),
      // para que em conexão boa o download siga a todo vapor com o vídeo rodando.
      //
      // O Vimeo é outro SDK: o evento de retomada lá é `play`, não `playing`, e
      // ele não expõe `waiting`/`seeking` — nessa fonte sobra o buffer do store.
      const playEvent = event.IsVimeo ? "play" : "playing";
      this.$refs.vdplayer.player.on(playEvent, () => { this._playbackActive = true; });
      this.$refs.vdplayer.player.on("pause", () => this.stopStreamingPlayback());
      this.$refs.vdplayer.player.on("ended", () => this.stopStreamingPlayback());

      if (!event.IsVimeo) {
        // `waiting` é o stall duro: o player parou por falta de dados. Vale
        // mesmo quando o buffer congela e o watcher abaixo deixa de disparar.
        // Buscar no vídeo também emite `waiting`, e aí a espera é do seek, não
        // da banda — por isso o par seeking/seeked serve de filtro.
        this.$refs.vdplayer.player.on("seeking", () => { this._seeking = true; });
        this.$refs.vdplayer.player.on("seeked", () => { this._seeking = false; });
        this.$refs.vdplayer.player.on("waiting", () => {
          if (this._playbackActive && !this._seeking) this.markPlaybackStruggling();
        });
      }

      // Aula baixada sobe com broadcast stub, sem chamada ao vdplayer — então o
      // `detalhes.posterUrl` que o bundle usa no streaming não existe aqui. Sem
      // poster, o WebView do Android pinta o placeholder padrão dele (cinza com
      // um ícone de play esticado); no iOS, um retângulo preto.
      //
      // O gate é `localSrc`, não `isOffline`: aula baixada tocando COM rede
      // também é reprodução local e caía nesse buraco.
      if (this.localSrc) {
        this.$refs.vdplayer.player.poster(this.resolvePosterUrl());
      }

      // A posição desta sessão (preservada no updateTime) tem precedência sobre
      // o offlineResumeFrom, que é uma estimativa derivada do % do grid. Só vale
      // se for a MESMA aula — na primeira montagem de cada aula não há posição
      // de sessão e o fallback assume.
      const currentBroadcast = this.learningObject && this.learningObject.broadcast;
      const sameLesson = currentBroadcast && this._resumeBroadcastId === currentBroadcast.id;
      // O ?time= entra como último recurso porque o conditionLasposition do
      // coremedia exige `startFrom < broadcast.duration`, e a fonte local sobe
      // com um broadcast stub de duration 0 — o seek dele nunca dispara em aula
      // baixada. Hoje o app só gera ?time=0 (falsy, ignorado nos dois caminhos),
      // então isto é rede de segurança pra um futuro "pular para o minuto X".
      const deepLinkAt = Number(this.$route.query.time) || 0;
      const resumeAt = sameLesson && this._resumeSeconds > 0
        ? this._resumeSeconds
        : (this.offlineResumeFrom || deepLinkAt);

      if (resumeAt > 0) {
        this.$refs.vdplayer.player.currentTime(resumeAt);
      }

      this.$emit("ready", event);
      this.$nextTick(() => this.overlayVisible = false);
    },
    updateOrientation() {
      this.currentOrientation = screen.orientation
        ? screen.orientation.angle
        : window.orientation;
    },
    handleUserActive() {
      this.userActive = true;
    },
    handleUserInactive() {
      this.userActive = false;
    },
    handlePlaybackRate(playbackRate, playbackRateCallback) {
      this.$store.dispatch("config/setInitialPlaybackRate", playbackRate);
      if (typeof playbackRateCallback === "function") {
        playbackRateCallback(playbackRate);
      }
    },
    showSettings() {
      this.settingsVisible = true;
    },
    hideSettings() {
      this.settingsVisible = false;
    },
    showNotes() {
      this.notesVisible = true;
      this.$refs.vdplayer.outFocus();
      this.$refs.vdplayer.pause();      
      /*
      setTimeout(() => {
        this.$refs.boxnotes.focus();
      });
      */
    },
    async createNote() {
      this.notesSending = true;
      if (!this.notesText) {
        this.$store.commit("toast/NEW", {
          type: "error",
          message: "A anotação está em branco",
          suppressOffline: true,
        });
        this.notesSending = false;
        return;
      }

      await this.$store.dispatch("note/create", {
        note: this.notesText,
        time: this.currentTime,
        enrollId: this.currentEnroll.id,
        courseId: this.currentEnroll.courseId,
        moduleId: this.currentLearningObject.moduleId,
        disciplineId: this.currentLearningObject.disciplineId,
        classId: this.currentLearningObject.classId,
        learningObjectId: this.currentLearningObject.id,
        previousClass: this.currentLearningObject.previousId,
        nextClass: this.currentLearningObject.nextId,
      });

      this.hideNotes();
      this.notesText = "";

      this.$store.commit("toast/NEW", {
        type: "success",
        message: "Anotação feita com sucesso!",
      });
      this.notesSending = false;
    },
    hideNotes() {
      this.notesVisible = false;
      this.$refs.vdplayer.enterFocus();
      this.$refs.vdplayer.play();
    },
    // Imagem da aula, preferindo a cópia local que o download já cacheou — o
    // imageMap é chaveado pela URL remota. Sem rede a remota não carrega, e era
    // exatamente o que a versão anterior tentava usar.
    resolvePosterUrl() {
      const image = this.learningObject && this.learningObject.image;
      if (image) {
        const local = (offlineStorage.getImageMap() || {})[image];
        if (local) return local;
        if (!this.isOffline) return image;
      }
      return this.buildFallbackPoster();
    },

    // Sem imagem utilizável, cobre a área do vídeo com um gradiente na cor do
    // produtor. SVG em data URI: escala sem borrar em qualquer tamanho (o
    // placeholder do WebView borra justamente por ser bitmap esticado), não
    // depende de rede nem de asset, e fecha bem nos dois temas.
    buildFallbackPoster() {
      const brand = (this.$theme && this.$theme.primaryColor) || "#5138ba";
      const svg =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 9" preserveAspectRatio="none">' +
        '<defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1">' +
        `<stop offset="0" stop-color="${brand}" stop-opacity="0.55"/>` +
        '<stop offset="1" stop-color="#0d0d13"/>' +
        "</linearGradient></defs>" +
        '<rect width="16" height="9" fill="url(#g)"/></svg>';
      return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
    },

    // Único ponto que mexe na flag lida pela fila de downloads. Aula baixada
    // (localSrc) toca do disco e nunca conta como consumo de banda.
    setStreamingPlayback(active) {
      this.$store.commit("dom/SET_STREAMING_PLAYBACK", active && !this.localSrc);
    },

    // O player está penando: cede banda já e cancela qualquer devolução em
    // andamento — a recuperação recomeça do zero na próxima janela boa.
    markPlaybackStruggling() {
      if (this.localSrc) return;
      this.cancelPlaybackRecovery();
      this.setStreamingPlayback(true);
    },

    // Devolve a banda só depois de RECOVERY_MS com o buffer confortável. O
    // timer é reagendado uma única vez: chamadas seguidas enquanto ele corre
    // não adiam a devolução.
    schedulePlaybackRecovery() {
      if (this._recoveryTimer) return;
      this._recoveryTimer = setTimeout(() => {
        this._recoveryTimer = null;
        this.setStreamingPlayback(false);
      }, RECOVERY_MS);
    },

    cancelPlaybackRecovery() {
      if (!this._recoveryTimer) return;
      clearTimeout(this._recoveryTimer);
      this._recoveryTimer = null;
    },

    // Fim da reprodução (pause, ended, saída da aula): zera tudo, inclusive a
    // marca de buffer saudável — a aula seguinte recomeça o aquecimento.
    stopStreamingPlayback() {
      this._playbackActive = false;
      this._seeking = false;
      this._bufferWasHealthy = false;
      this.cancelPlaybackRecovery();
      this.setStreamingPlayback(false);
    },
    handleStarted(e) {
      if (e.muted) {
        if (this.$isApp) {
          this.$refs.vdplayer.setMute(false);
        } else {
          this.unmuteVisible = true;
        }
      }
    },
    handleEnded() {
      this.$emit("ended");
    },
    handleEnterFullscreen() {
      // Fullscreen via CSS (rotação 90°) ativado pela classe .fs.
      // Usado no iOS app pra evitar a Fullscreen API do WKWebView, que
      // congela env(safe-area-inset-*) após sair do fullscreen + rotação.
      this.fullscreen = true;
      document.body.classList.add('player-fullscreen');
      this.pushFullscreenHistoryEntry();
      this.lockBackgroundScroll();
      // O swipe-back nativo fica DESLIGADO durante o fullscreen. A travessia
      // interativa do WKWebView anima com snapshots por entrada de histórico, e
      // a entrada descartável (mesma URL, via pushState) não ganha snapshot —
      // o WebKit mostrava a foto da PÁGINA ANTERIOR (o curso) e "quicava" de
      // volta pro DOM vivo da aula ao commitar. O fechamento por gesto é
      // reimplementado em handleFsEdgeTouchMove; a entrada descartável fica
      // como defesa caso o toggle nativo falhe (pior caso = quique cosmético,
      // nunca sair da aula).
      this.setNativeSwipeBack(false);
      this.$emit('enterfullscreen');
    },

    // Voltar em fullscreen deve fechar o fullscreen e ficar na aula.
    //
    // Não dá para conseguir isso barrando a navegação: o swipe do WKWebView
    // (allowsBackForwardNavigationGestures, ligado no BridgeViewController) é um
    // gesto NATIVO e a travessia é commitada pelo WebKit antes de o JS ver
    // qualquer coisa. `popstate` é notificação, não evento cancelável — abortar a
    // transição do vue-router preserva a árvore renderizada, mas não desfaz o que
    // o WebKit já fez, e a página voltava de todo jeito.
    //
    // Então em vez de brigar com o gesto, damos a ele algo inócuo para consumir:
    // ao entrar em fullscreen empilhamos uma entrada com a MESMA URL. O voltar
    // consome essa entrada — travessia real, WebKit satisfeito, nenhuma rota
    // trocada — e o popstate resultante é o nosso sinal para fechar o fullscreen.
    //
    // A URL idêntica também é o que mantém o vue-router fora do caminho: o
    // `confirmTransition` descarta navegação para a mesma rota ANTES de montar a
    // fila de guards, então o beforeRouteLeave do StudentClass não chega a rodar.
    pushFullscreenHistoryEntry() {
      if (this._fsHistoryEntry) return;
      this._fsHistoryEntry = true;
      history.pushState({ vxlPlayerFullscreen: true }, '');
    },

    // Saída pelo próprio player (botão, autoNext, troca de fonte): a entrada
    // precisa sair do histórico, senão fica sobrando e o próximo voltar do aluno
    // é gasto sem efeito visível. O history.back() aqui não navega — a entrada
    // tem a URL desta aula, então ele apenas volta ao registro de baixo.
    releaseFullscreenHistoryEntry() {
      if (!this._fsHistoryEntry) return;
      this._fsHistoryEntry = false;
      this._fsReleasingEntry = true;
      history.back();
    },

    handleHistoryBack() {
      // Nosso próprio release chegando de volta; não é o aluno pedindo nada.
      if (this._fsReleasingEntry) {
        this._fsReleasingEntry = false;
        return;
      }
      if (!this._fsHistoryEntry) return;
      // Zerado ANTES do reset: a entrada acabou de ser consumida pelo voltar, e
      // sem isso o reset chamaria release e comeria uma segunda entrada — aí sim
      // saindo da aula.
      this._fsHistoryEntry = false;
      this.resetFullscreenState();
    },
    handleExitFullscreen() {
      this.resetFullscreenState();
    },

    // Sai do fullscreen-por-CSS sem depender do evento do player.
    //
    // O estado vive no WRAPPER, que sobrevive à troca de aula — só o
    // <vd-coremedia> é recriado, pela playerKey. Como `fullscreen` só voltava a
    // false pelo `exitfullscreen`, bastava o player sumir em fullscreen pra
    // ficar preso: com autoNext no iOS, terminar a aula assim leva o `.fs`
    // (position: fixed, z-index: 99999, 100dvw/100dvh) pra aula seguinte, que
    // abre cobrindo a página enquanto o player NOVO acha que não está em
    // fullscreen — só dois toques no botão recuperam. E sair da rota nesse
    // estado deixava `body.player-fullscreen` grudado, escondendo o
    // chaindesk-chatbox no app inteiro até um novo ciclo entrar/sair.
    //
    // A classe do body é removida sempre (idempotente); o emit só sai se havia
    // fullscreen de fato, pra não avisar o pai de uma saída que não houve.
    resetFullscreenState() {
      document.body.classList.remove('player-fullscreen');
      this.releaseFullscreenHistoryEntry();
      this.unlockBackgroundScroll();
      this.setNativeSwipeBack(true);
      this.exitPlayerFullscreen();
      if (!this.fullscreen) return;
      this.fullscreen = false;
      this.$emit('exitfullscreen');
    },

    // Tranca o scroll do body enquanto o overlay .fs cobre a tela. O .fs é
    // position:fixed, e no iOS o WebKit encadeia o toque de um fixed sem nada
    // rolável para o body por baixo — dava pra rolar a página da aula "às
    // cegas" atrás do vídeo. `overflow: hidden` não basta no iOS; body fixo com
    // top negativo é a técnica que segura, preservando a posição de scroll.
    // Android não precisa (o full-window do video.js já marca overflow) e o
    // caminho nem roda lá: só handleEnterFullscreen chama.
    lockBackgroundScroll() {
      if (this._fsScrollLockY != null) return;
      this._fsScrollLockY = window.scrollY || document.documentElement.scrollTop || 0;
      const bs = document.body.style;
      bs.position = 'fixed';
      bs.top = `-${this._fsScrollLockY}px`;
      bs.left = '0';
      bs.right = '0';
      bs.width = '100%';
    },

    unlockBackgroundScroll() {
      if (this._fsScrollLockY == null) return;
      const y = this._fsScrollLockY;
      this._fsScrollLockY = null;
      const bs = document.body.style;
      bs.position = '';
      bs.top = '';
      bs.left = '';
      bs.right = '';
      bs.width = '';
      window.scrollTo(0, y);
    },

    // Guardado por flag pra não disparar bridge call em cada passagem do
    // resetFullscreenState (ele roda em troca de aula/destroy mesmo sem
    // fullscreen ativo). O catch engole: num shell antigo sem o plugin a
    // chamada rejeita, o gesto continua ligado e a entrada descartável segura
    // o comportamento (com o quique cosmético de antes).
    setNativeSwipeBack(enabled) {
      if (!this.$isIos) return;
      if (this._fsSwipeDisabled === !enabled) return;
      this._fsSwipeDisabled = !enabled;
      VxlNavGestures.setSwipeBackEnabled({ enabled }).catch(() => {});
    },

    // Reimplementação em JS do gesto de voltar DURANTE o fullscreen iOS (o
    // nativo fica desligado — ver handleEnterFullscreen): arrasto que nasce na
    // borda esquerda e anda >60px na horizontal fecha o fullscreen. O limiar
    // de 24px da borda evita conflito com a barra de progresso do player, cujo
    // início fica além do safe-area lateral em paisagem.
    handleFsEdgeTouchStart(e) {
      if (!this.fullscreen || !this.$isIos) {
        this._fsEdgeTouch = null;
        return;
      }
      const t = e.touches[0];
      this._fsEdgeTouch = t.clientX <= 24 ? { x: t.clientX, y: t.clientY } : null;
    },

    handleFsEdgeTouchMove(e) {
      if (!this._fsEdgeTouch || !this.fullscreen) return;
      const t = e.touches[0];
      const dx = t.clientX - this._fsEdgeTouch.x;
      const dy = Math.abs(t.clientY - this._fsEdgeTouch.y);
      // Exige gesto claramente horizontal (dx > 1.5*dy) pra não fechar em
      // rolagem vertical que encostou na borda.
      if (dx > 60 && dx > dy * 1.5) {
        this._fsEdgeTouch = null;
        this.resetFullscreenState();
      }
    },

    // `fullscreen` (e todo o caminho da classe .fs) só existe quando
    // customFullscreen está ligado, e ele é `$isIos`. No bundle, o
    // `buildBtnFullscreen` só troca o FullscreenToggle pelo botão que emite
    // enterfullscreen/exitfullscreen sob essa flag — no Android o toggle nativo
    // do video.js permanece e esta flag NUNCA fica true. Ou seja: fora do iOS o
    // fullscreen não é nosso, e nada aqui o desfazia. Sair da rota (ou o
    // autoNext) deixava o documento em fullscreen com o player composto acima da
    // tela nova.
    //
    // Quem sabe desfazer é o próprio video.js: ele escolheu entre a Fullscreen
    // API e o fallback de full-window — que marca o `body` e o
    // `documentElement.style.overflow`, fora da árvore deste componente, onde a
    // destruição do Vue não alcança. E o fallback é o caso provável aqui: o
    // BridgeWebChromeClient do Capacitor responde `onShowCustomView` com
    // `onCustomViewHidden()` imediato, então o shell não sustenta fullscreen
    // nativo de vídeo.
    //
    // Roda em beforeDestroy antes do teardown dos filhos, então o ref ainda é
    // válido. O document.exitFullscreen é rede de segurança para o caso de a
    // instância já ter sido descartada.
    exitPlayerFullscreen() {
      const player = this.$refs.vdplayer && this.$refs.vdplayer.player;
      try {
        if (player && typeof player.isFullscreen === 'function' && player.isFullscreen()) {
          player.exitFullscreen();
        }
      } catch (e) { /* player já descartado */ }
      try {
        if (this.nativeFullscreenElement() && document.exitFullscreen) {
          document.exitFullscreen();
        } else if (this.nativeFullscreenElement() && document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
      } catch (e) { /* exitFullscreen rejeita fora de fullscreen */ }
    },

    // Restringido à subárvore deste componente de propósito: um
    // `document.fullscreenElement` qualquer não é do player, e tirar do fullscreen
    // algo que não é nosso seria pior que não fazer nada.
    nativeFullscreenElement() {
      const el = document.fullscreenElement || document.webkitFullscreenElement;
      if (!el || !this.$el) return null;
      return this.$el.contains(el) ? el : null;
    },
    handleUnmute() {
      this.$refs.vdplayer.setMute(false);
      this.unmuteVisible = false;
    },
    toggleLibras() {
      this.librasVisible = !this.librasVisible;
    },

    navigatePreviousClass() {
      if (!this.currentLearningObject.previousId) return;

      this.$router.push({
        name: "class",
        params: {
          enrollId: this.currentEnroll.id,
          id: this.currentLearningObject.previousId,
        },
      });
    },
    navigateNextClass(auto) {
      if (!this.currentLearningObject.nextId) return;

      var routerParams = {
        name: "class",
        params: {
          enrollId: this.currentEnroll.id,
          id: this.currentLearningObject.nextId,
        },
      };
      if (auto) routerParams.query = { time: 0 }; //pq não funciona 0?

      this.$router.push(routerParams);
    },
  },
  filters: {
    time(value) {
      var h = Math.floor(value / 60);
      var m = Math.floor(value % 60);

      if (h < 10) h = "0" + h;
      if (m < 10) m = "0" + m;

      return h + ":" + m;
    },
  },
};
</script>

<style scoped>
.player {
  position: relative;
  text-align: center;
  width: 100%;
  padding-bottom: 56.25%;
  max-height: 100vh;
  background-color: transparent;
  margin: auto;
  z-index: 10;
  border-radius: 10px;
  overflow: hidden;
}



/* Cobre a área do player até o `ready`. Precisa de regra própria porque o
   `_login.scss` é importado global (style.scss) e define `.overlay::before`
   como o véu pontilhado da tela de login — sem isto, era essa textura que
   aparecia no player enquanto o manifesto não chegava. O seletor scoped ganha
   do global por especificidade, e o `content: none` mata o vazamento. */
.player .overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000;
  border-radius: 10px;
  z-index: 5;
}

.player .overlay::before {
  content: none;
}

.player .unmute {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
}

.player .video-nav-prev,
.player .video-nav-next {
  height: 100%;
  width: 21.4%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  /* overflow: hidden; */
}

.btn-nav-video {
  background: #0d0d13;
  border: 2px solid white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.player .video-nav-prev {
  left: -21.4%;
}

.player .video-nav-next {
  right: -21.4%;
}

.player .video-nav-prev #video-nav-details-prev,
.player .video-nav-next #video-nav-details-next {
  width: 100%;
  height: 150px;
  z-index: 1;
  background: black;
  position: absolute;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.nav-details-img {
  width: 90%;
  height: 60%;
  margin-bottom: 10px;
  object-fit: contain;
}

.nav-details-name {
  font-family: "Montserrat";
  font-size: 12px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}

.player .video-nav-prev #video-nav-details-prev {
  /* left: -90%; */
  left: 30%;
  opacity: 0;
  transition-property: left, right;
  transition-duration: 2s;
}
.player .video-nav-next #video-nav-details-next {
  /* right: -90%; */
  right: 30%;
  opacity: 0;
  transition-property: right, left;
  transition-duration: 2s;
}

.player .video-nav-prev a:hover ~ #video-nav-details-prev {
  /* left: 0; */
  opacity: 1;
  pointer-events: none;
}

.player .video-nav-next a:hover ~ #video-nav-details-next {
  pointer-events: none;
  opacity: 1;
  /* right: 0; */
}

.player .unmute a.waves-effect.btn-large {
  background-color: rgba(0, 0, 0, 0.45);
}

.player video {
  width: 100vw;
}
.player #controllers {
  display: block;
}
.player .bar-right {
  display: flex;
  position: absolute;
  /* width: 30px; */
  /* height: 60%; */
  right: 5px;
  top: 0.5rem;
  /* bottom: 46px; */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  transition: 0.5s ease-in-out;
  z-index: 9;
  overflow: hidden;
}
.vimeo {
  /* right: 55px !important;
  top: 10px !important; */
  right: 10px !important;
  top: 140px !important;
  opacity: 0;
  transition: 140ms ease-in-out !important;
}

.vimeo .right-button {
  background: rgba(23, 35, 34, 0.75) !important;
  margin-bottom: 6px !important;
  width: 2.5em !important;
  height: 2.5em !important;
}
.active {
  opacity: 1;
}

#coremedia:hover ~ #barRight.vimeo {
  border: 1px solid red;
}

@media all and (max-width: 500px) {
  .vimeo {
    
    left: 0px !important;
    width: 50px;
    top: 10px !important;
  }

}

.player .bar-right .right-button {
  margin-bottom: 3px;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.5s ease-in-out;
  height: 2.5rem;
  width: 2.5rem;
  right: -40px;
  position: relative;
}
.player .bar-right .right-button img {
  /* height: 25px; */
  height: 60%;
  width: 60%;
}
.player .bar-right .right-button svg {
  width: 50%;
  height: 50%;
}
.player .move {
  right: 0px !important;
}
.player .modals {
  z-index: 10;
  flex-direction: column;
  position: absolute;
  text-align: center;
  width: 100%;
  height: 100%; /* 56.25vw;*/
  background-color: rgba(0, 0, 0, 0.9);
  top: 0;
  right: 0;
  /* padding: 8px 18px; */
  padding: 2px 6px;
  box-sizing: border-box;
  display: none;
  font-family: "Montserrat";
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}
.player .modals .modal-header {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 20%;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #fff;
  /* Rounded sliders */
}
.player .modals .modal-header .modal-title {
  font-family: "Montserrat";
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  display: flex;
  align-items: center;
}
.player .modals .modal-header .modal-title img {
  padding-right: 10px;
}
.player .modals .modal-header .modal-close {
  right: 12px;
  background-color: Transparent;
  color: white;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  font-family: "Montserrat";
  font-size: 24px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
}
.player .modals .modal-header .modal-switch {
  position: absolute;
  display: inline-block;
  width: 50px;
  height: 24px;
  right: 17vw;
}
.player .modals .modal-header .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.player .modals .modal-header .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #bfbfbf;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.player .modals .modal-header .slider::after {
  content: "";
}
.player .modals .modal-header .slider:before {
  position: absolute;
  content: "";
  height: 17px;
  width: 17px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.player .modals .modal-header input:checked + .slider {
  background-color: #2196f3;
}
.player .modals .modal-header input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
.player .modals .modal-header input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.player .modals .modal-header .slider.round {
  border-radius: 24px;
}
.player .modals .modal-header .texto {
  font-family: "Montserrat";
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  position: absolute;
  width: 65px;
  /* text-align: end; */
  right: 55px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.player .modals .modal-header .slider.round:before {
  border-radius: 50%;
}
.player .modal-content {
  width: 100%;
  height: 85%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 10px;
}
.player .modal-box-notes {
  height: 60%;
  overflow: hidden;
}
.player .modal-box-notes textarea {
  width: 100%;
  height: 100%;
  font-family: "Montserrat";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  background: transparent;
  border: none;
  resize: none;
}
.player .modal-box-notes textarea:focus,
.player .modal-box-notes input:focus {
  outline: none;
}
.player .notes-group1 {
  height: 15%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.player .notes-group1 .notes-count {
  font-family: "Montserrat";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #7f7f7f;
}
.player .notes-group1 .notes-send {
  display: flex;
  align-items: center;
  font-family: "Montserrat";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #48daac;
  cursor: pointer;
}
.player .notes-group1 .notes-send .spinner-layer {
  border-color: #48daac;
}
.player .notes-group2 {
  height: 25%;
  padding: 5px 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
}
.player .notes-group2 .note-time-video {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 25px;
  background: blue;
  font-family: "Montserrat";
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}
.player .notes-group2 .note-msg {
  padding-left: 20px;
  font-family: "Montserrat";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: italic;
  line-height: normal;
  letter-spacing: normal;
  color: #7f7f7f;
}
.player .modal-section,
.player .modal-options {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 65%;
}
.player .modal-section {
  padding-top: 20px;
}
.player .modal-options {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding-top: 5px;
}
.player .modal-btn-option {
  background-color: Transparent;
  color: white;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  font-family: "Montserrat";
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #7f7f7f;
}
.player .active {
  color: #fff;
  font-weight: 600;
}

#player {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 0;
}

.fs-z-index {
  z-index: -1 !important;
  position: relative;
}

/* Fullscreen customizado: cobre toda a viewport na orientação atual.
   Usa dvw/dvh (dynamic viewport units) para evitar o freeze de env()
   que ocorre após Fullscreen API + mudança de orientação no iOS. */
.fs {
  position: fixed;
  z-index: 99999;
  background: black;
  left: 0;
  top: 0;
  width: 100dvw;
  height: 100dvh;
  max-height: none; /* override do .player que tem max-height: 100vh */
  padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
  box-sizing: border-box;
}
.full {
  padding-top: 100vw !important;
}

.bitrate-control button.selected,
.playback-rate-control button.selected {
  font-weight: bold;
  color: #ffffff;
}

.toggles {
  position: absolute;
  right: 50px;
}

.modal-toggle,
.modal-toggle:active {
  position: absolute;
  top: -5000px;
  height: 0;
  width: 0;
  opacity: 0;
  border: none;
  outline: none;
}

.checkbox-label {
  display: block;
  position: relative;
  padding: 10px;
  font-size: 12px;
  line-height: 16px;
  width: 50px;
  height: 20px;
  -webkit-border-radius: 18px;
  -moz-border-radius: 18px;
  border-radius: 18px;
  background: #bfbfbf;
  cursor: pointer;
}

.checkbox-label:before {
  content: "";
  display: block;
  position: absolute;
  z-index: 1;
  line-height: 34px;
  text-indent: 40px;
  height: 20px;
  width: 20px;
  -webkit-border-radius: 100%;
  -moz-border-radius: 100%;
  border-radius: 100%;
  top: 0px;
  left: 0px;
  right: auto;
  background: white;
  -webkit-box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2), 0 0 0 2px #bfbfbf;
  -moz-box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2), 0 0 0 2px #bfbfbf;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2), 0 0 0 2px #bfbfbf;
}

.checkbox-label:after {
  content: attr(data-off);
  display: block;
  position: absolute;
  z-index: 0;
  top: 3px;
  left: -305px;
  height: 100%;
  width: 300px;
  text-align: right;
  color: #bfbfbf;
  white-space: nowrap;
}

.modal-toggle:checked + .checkbox-label {
  -webkit-box-shadow: inset 0 0 0 20px #2196f3, 0 0 0 2px #2196f3;
  -moz-box-shadow: inset 0 0 0 20px #2196f3, 0 0 0 2px #2196f3;
  box-shadow: inset 0 0 0 20px #2196f3, 0 0 0 2px #2196f3;
}

.modal-toggle:checked + .checkbox-label:before {
  left: calc(100% - 20px);
  -webkit-box-shadow: 0 0 0 2px transparent, 0 3px 3px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0 0 0 2px transparent, 0 3px 3px rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 0 2px transparent, 0 3px 3px rgba(0, 0, 0, 0.3);
}

.modal-toggle:checked + .checkbox-label:after {
  content: attr(data-on);
  left: -48px;
  width: 26px;
}

#checkbox1,
#checkbox2 + .checkbox-label {
  -webkit-box-shadow: inset 0 0 0 0px #2196f3, 0 0 0 2px #bfbfbf;
  -moz-box-shadow: inset 0 0 0 0px #2196f3, 0 0 0 2px #bfbfbf;
  box-shadow: inset 0 0 0 0px #2196f3, 0 0 0 2px #bfbfbf;
}

#checkbox1:checked,
#checkbox2:checked + .checkbox-label {
  -webkit-box-shadow: inset 0 0 0 18px #2196f3, 0 0 0 2px #2196f3;
  -moz-box-shadow: inset 0 0 0 18px #2196f3, 0 0 0 2px #2196f3;
  box-shadow: inset 0 0 0 18px #2196f3, 0 0 0 2px #2196f3;
}

#checkbox1:checked,
#checkbox2:checked + .checkbox-label:after {
  color: #2196f3;
}

#boxLibras {
  display: none;
}

#btnLibrasFullscreen {
  display: none;
}

#boxLibrasFullScreen {
  display: none;
  height: 130px;
}

.libras-button {
  position: absolute;
  bottom: 0.5rem;
  right: 0.5rem;
  transition: 0.5s ease-in-out;
  /* width: 120px !important; */
  /* height: 120px !important; */
  /* background-color: transparent !important;*/
}
.upLibras {
  bottom: 5.5rem;
  transition: 0.5s ease-in-out;
}

.box-Libras-FullScreen {
  width: 120px;
  height: 120px;
  position: relative;
  border-radius: 9999px;
  overflow: hidden;
}
.box-Libras-FullScreen .libras {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  background: white;
  border-radius: 50%;
  overflow: hidden;
}
.box-Libras-FullScreen .libras video {
  max-width: 200px;
  max-height: 200px;
}

.box-libras {
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 150px;
  background: #3b3b3b;
  -webkit-transition: 0.9s;
  transition: 0.9s;
  /* position: fixed; */
}
.box-libras .libras {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  background: white;
  border-radius: 50%;
  overflow: hidden;
}
.box-libras .libras video {
  max-width: 200px;
  max-height: 200px;
}

.preloader-wrapper.smaller {
  width: 25px;
  height: 25px;
  margin-right: 5px;
}
</style>

<style>
#videojsPlayer:not(.video-js)>div:first-child {
  padding-top: 56.25% !important;
}
#videojsPlayer.video-js {
  /* padding-top: 56.25% !important; */
}

/* No fullscreen, força o video.js a preencher a viewport real usando dvw/dvh.
   Sem isso, o video.js usa padding-top: 56.25% (aspect 16:9).
   dvw/dvh são valores absolutos e bypassa a cadeia de divs sem altura do video.js.
   Precisa estar fora do <style scoped> para alcançar os elementos do video.js. */
.fs .video-js.vjs-fluid {
  padding-top: 0 !important;
  width: calc(100dvw - env(safe-area-inset-left) - env(safe-area-inset-right)) !important;
  height: calc(100dvh - env(safe-area-inset-top) - env(safe-area-inset-bottom)) !important;
}
</style>